import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import getHOCDisplayName from "../service/getHOCDisplayName";
var withDataLoader = function withDataLoader(WrappedComponent) {
  var DataLoader = /*#__PURE__*/function (_PureComponent) {
    _inherits(DataLoader, _PureComponent);
    var _super = _createSuper(DataLoader);
    function DataLoader(props) {
      var _this;
      _classCallCheck(this, DataLoader);
      _this = _super.call(this, props);
      _this.loadDataResolver = _this.loadDataResolver.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(DataLoader, [{
      key: "loadDataResolver",
      value: function () {
        var _loadDataResolver = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dataResolver) {
          var _this$props, loaderHandler, errorHandler, result;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, loaderHandler = _this$props.loaderHandler, errorHandler = _this$props.errorHandler;
                loaderHandler.start();
                _context.prev = 2;
                _context.next = 5;
                return dataResolver();
              case 5:
                result = _context.sent;
                errorHandler.clearError();
                return _context.abrupt("return", result);
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                throw _context.t0;
              case 13:
                _context.prev = 13;
                loaderHandler.stop();
                return _context.finish(13);
              case 16:
              case "end":
                return _context.stop();
            }
          }, _callee, this, [[2, 10, 13, 16]]);
        }));
        function loadDataResolver(_x) {
          return _loadDataResolver.apply(this, arguments);
        }
        return loadDataResolver;
      }()
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          dataLoaderHandler: {
            loadDataResolver: this.loadDataResolver
          }
        }));
      }
    }]);
    return DataLoader;
  }(PureComponent);
  DataLoader.propTypes = {
    errorHandler: PropTypes.shape({
      clearError: PropTypes.func.isRequired
    }).isRequired,
    loaderHandler: PropTypes.shape({
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    }).isRequired
  };
  DataLoader.displayName = getHOCDisplayName(WrappedComponent, 'DataLoader');
  return DataLoader;
};
export default withDataLoader;
export var propTypes = {
  dataLoaderHandler: PropTypes.shape({
    loadDataResolver: PropTypes.func.isRequired
  }).isRequired
};